import React, {JSX} from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface AuthRouteProps {
    element: JSX.Element;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ element }) => {
    const { isAuth, loading } = useAuth();

    if (loading) {
        return (
            <div style={{ height: "90vh", paddingTop: 100 }}>
                <div className="spinner-wrapper">
                    <div className="spinner"></div>
                </div>
            </div>
        );
    }

    if (!isAuth) {
        return <Navigate to="/login" replace />;
    }

    return element;
};

export default AuthRoute;
